let asItemTable = [
  {
    label: "序号",
    prop: "id",
  },
  {
    label: "人员姓名",
    prop: "name",
  },
  {
    label: "科室",
    prop: "departmentName",
  },
  {
    label: "加/减分事由",
    prop: "itemDetail",
  },
  {
    label: "分数",
    prop: "score",
  },
  {
    label: "证明材料",
    prop: "appendix",
  },
]


export {
  asItemTable
}